import React, { useState, useRef, useEffect } from "react";
import closeIcon from "../../Assets/Icons/close.png";
import Input from "../../Components/Input";
import Dropdown from "../../Components/Dropdown";
import { postData } from "../../ApiServices/ApiService";
import { ORG_EXPENSE_TYPE_CRUD } from "../../ApiServices/BaseURL";
import Loader from "../../Components/Loader";
import { logFrontendException } from "../../Utils/Exception";
import { useTheme } from "../../GlobalContext/GlobalContext";


const NatureExpenseForm = ({ onClose, onValueChange, editData = null, isOpen }) => {
    const [form, setForm] = useState({
        name: "",
        description: "",
        status: null
    });

    const [errors, setErrors] = useState({});
    const [loading, setLoading] = useState(false);
    const [success, setSuccess] = useState("");
    const [error, setError] = useState("");

    const pageName = 'NatureExpenseForm';
    const storedUserId = JSON.parse(localStorage.getItem("_userInfo_"))?.emp_id;
    const { setIsLoginPopup } = useTheme();
    const [openDropdown, setOpenDropdown] = useState(null);
    const dropdownRefs = useRef({});

    const toggleDropdown = (dropdownName) => {
        setOpenDropdown((prev) => (prev === dropdownName ? null : dropdownName));
    };

    const handleChange = (name, value) => {
        setForm((prev) => ({ ...prev, [name]: value }));
        setErrors((prev) => ({ ...prev, [name]: "" }));
    };

    useEffect(() => {
        const handleClickOutside = (event) => {
            const isOutside = Object.keys(dropdownRefs.current).every(
                (key) => dropdownRefs.current[key] && !dropdownRefs.current[key].contains(event.target)
            );
            if (isOutside) {
                setOpenDropdown(null);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);

    useEffect(() => {
        if (editData) {
            setForm({
                name: editData?.name || "",
                description: editData?.description || "",
                status: {label:editData?.status === 1 ? "Active" :"Disabled",value: editData?.status} 
            });
        } else {
            clearFields();
        }
    }, [editData, isOpen]);

    const clearFields = () => {
        setForm({ name: "", description: "", status: null });
        setErrors({});
        setSuccess("");
        setError("");
    };

    const validateFields = () => {
        let hasError = false;
        const newErrors = {};

        if (!form.name) {
            newErrors.name = "Please enter expense name";
            hasError = true;
        }

        if (form.status?.value === null || form.status?.value === undefined) {
            newErrors.status = "Please select status";
            hasError = true;
        }

        setErrors(newErrors);
        return !hasError;
    };

    const handleSubmit = async () => {
        if (!validateFields()) return;

        setLoading(true);
        setSuccess("");
        setError("");

        try {
            var methodName= editData ? 'handleSubmit-edit':'handleSubmit-add';
            const storedUserInfo = JSON.parse(localStorage.getItem("_userInfo_"));
            const payload = {
                "action_code": editData ? "EDIT_EXPENSE_TYPE" : "ADD_EXPENSE_TYPE",
                "name": form.name,
                "description": form.description,
                "status":form.status?.value || 0,
                "emp_id_auth": storedUserInfo?.emp_id
            };


            if (editData) {
                payload.expense_type_id = editData.id;
            }

            const response = await postData(ORG_EXPENSE_TYPE_CRUD, payload);
            const responseData = await response.json();

            if (response.status === 200 && responseData?.status_code === 200) {
                if (responseData.message.toLowerCase() === "success") {
                    setSuccess(responseData.info || "Saved successfully.");
                    setTimeout(() => {
                        onClose();
                        onValueChange && onValueChange();
                    }, 2000);
                } else {
                    setError(responseData.info || "Something went wrong.");
                    // Log exception to backend (User Id,Page Name,Method Name,Response/error)
                    logFrontendException( storedUserId, pageName, methodName, responseData || '');
                }
            }  else if (response?.status === 400 || response?.status === 401 || response?.status === 403) {
                setError('Unauthorized access. Your session may have expired. Please log in again.');
                    setIsLoginPopup(true)
                    // Log exception to backend (User Id,Page Name,Method Name,Response)
                    logFrontendException(storedUserId, pageName, methodName, responseData || response || '');
            
                } else {
                setError(responseData.info || "Failed. Try again.");
                //  Log exception to backend (User Id,Page Name,Method Name,Response/error)
                logFrontendException( storedUserId, pageName, methodName, responseData || response || '');
            }
        } catch (err) {
            setError("Network error. Please try again.");
            // Log exception to backend (User Id,Page Name,Method Name,Response/error)
            logFrontendException( storedUserId, pageName, methodName, err || '');
        } finally {
            setLoading(false);
        }
    };

    const statusOptions = [
        { label: "Active", value: 1 },
        { label: "Disabled", value: 0 }
    ];

    const resetForm = () => {
        setForm({ name: "", description: "", status: null });
        setErrors({});
        setSuccess("");
        setError("");
        onClose();
    }

    return (
        <div className="modal-overlay">
            <div className="modal-content">
                <button className="close-button" onClick={onClose}>
                    <img src={closeIcon} alt="Close" style={{ width: 15, height: 15 }} />
                </button>

                <h2 className="modal-title">{editData ? "Update" : "Add New"} Expense Type</h2>
                <hr className="title-divider" />

              
                <div style={styles.formGroup}>
                    <div>
                        <Input
                            label="Expense Name"
                            name="name"
                            value={form.name}
                            onChange={(e) => handleChange("name", e.target.value)}
                            placeholder="Enter expense name"
                            style={styles.input}
                            errorMessage={errors.name}
                        />
                    </div>

                    <div>
                        <Input
                            label="Description"
                            name="description"
                            value={form.description}
                            onChange={(e) => handleChange("description", e.target.value)}
                            placeholder="Enter description"
                            style={styles.input}
                        />
                    </div>

                    <div>
                        <Dropdown
                            ref={(el) => (dropdownRefs.current["status"] = el)}
                            isOpen={openDropdown === "status"}
                            toggleDropdown={() => toggleDropdown("status")}
                            name="status"
                            label="Status"
                            options={statusOptions}
                            value={form.status}
                            onChange={(value) => handleChange("status", value)}
                            errorMessage={errors.status}
                            searchBoxWidth={260}
                            disabledSelect={true}
                        />
                    </div>
                </div>

                <hr style={styles.divider} />
                {error && <div className="list-error-msg" >{error}</div>}
                {success && <div className="list-success-msg" >{success}</div>}

                <div style={styles.buttonContainer}>
                    <button
                        className="add-client-button"
                        onClick={handleSubmit}
                        disabled={loading}
                        style={{
                            paddingLeft: 30,
                            paddingRight: 30,
                            opacity: loading ? 0.5 : 1,
                            cursor: loading ? "not-allowed" : "pointer"
                        }}
                    >
                        <span style={{ paddingRight: loading ? 10 : 0 }}>
                            <Loader loading={loading} color="#FFFFFF" size="small" />
                        </span>
                        {editData ? "Update" : "Add"}
                    </button>
                    <button className="cancel-button" onClick={() => { resetForm(); }}>Cancel</button>
          
                </div>
            </div>
        </div>
    );
};

const styles = {
    divider: {
        border: "none",
        borderTop: "1px solid #D6E4EC",
        margin: "10px 0"
    },
    formGroup: {
        display: "flex",
        flexDirection: "column",
        gap: "16px",
        marginBottom: "16px"
    },
    label: {
        fontSize: "12px",
        color: "#343c44",
        fontWeight: "500"
    },
    input: {
        // width: "100%",
        padding: "10px",
        border: "1px solid #D6E4EC",
        borderRadius: "2px",
        fontSize: "14px"
    },
    buttonContainer: {
        display: "flex",
        gap: "12px",
        justifyContent: "flex-start",
        marginTop: "20px"
    }
};

export default NatureExpenseForm;


